import Vue from 'vue';
import App from './App.vue';
import VueMeta from 'vue-meta';
import router from './router';
import VueResource from 'vue-resource';
import Meta from 'vue-meta';
import './registerServiceWorker';


Vue.config.productionTip = false;

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faEnvelope }  from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp }  from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faWhatsapp, faEnvelope)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Meta);
Vue.use(VueResource);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app');
